import { cilAccountLogout, cilContrast, cilEye, cilEyeSlash, cilMoon, cilSettings, cilSun } from "@coreui/icons-pro";
import CIcon from "@coreui/icons-react";
import {
    CAvatar,
    CButton,
    CButtonGroup,
    CCol,
    CDropdown,
    CDropdownDivider,
    CDropdownItem,
    CDropdownMenu,
    CDropdownToggle,
    CForm,
    CFormLabel,
    CLoadingButton,
    CModal,
    CModalBody,
    CModalFooter,
    CModalHeader,
    CModalTitle} from "@coreui/react-pro";
import { useContext, useState } from "react";
import defaultUser from '../assets/images/layout/default_user.jpg'
import { AppContext } from "../contexts/App";
import useToast from "../hooks/toast";
import api from "../utils/api";
import { AUTH_LOGOUT } from "../constants/endpoint";

export default function HeaderDropdownUserLogout() {
    const [showModalLogout, setshowModalLogout,] = useState(false)
    const [showModalSetting, setShowModalSetting,] = useState(false)
    const { user } = useContext(AppContext)
    return (
        <>
            <CDropdown variant="nav-item">
                <CDropdownToggle caret={false} >
                    <CAvatar src={user?.profile?.picture || defaultUser} />
                </CDropdownToggle>
                <CDropdownMenu>
                    <CDropdownItem
                        style={{ cursor: 'pointer' }}
                        onClick={(e) => {
                            setShowModalSetting(showModalSetting ? false : true)
                        }}
                    >
                        <CIcon icon={cilSettings} className="me-2" />
                        Settings
                    </CDropdownItem>
                    <CDropdownDivider />
                    <CDropdownItem
                        className='text-danger'
                        style={{ cursor: 'pointer' }}
                        onClick={(e) => {
                            setshowModalLogout(showModalLogout ? false : true)
                        }}
                    >
                        <CIcon icon={cilAccountLogout} className="me-2" />
                        Keluar
                    </CDropdownItem>
                </CDropdownMenu>
            </CDropdown>
            <ModalLogout
                visible={showModalLogout}
                setVisible={setshowModalLogout}
            />
            <ModalSetting
                visible={showModalSetting}
                setVisible={setShowModalSetting}
            />
        </>
    )
}


function ModalLogout({ visible, setVisible }: { visible: boolean, setVisible: (x: boolean) => void }) {
    const [addToast] = useToast()
    const [loading, setLoading] = useState(false)

    return (
        <CModal portal backdrop={'static'} size='sm' visible={visible} onClose={() => { setVisible(false) }}>
            <CModalBody>
                <>Anda yakin ingin keluar?</>
            </CModalBody>
            <CModalFooter>
                <CButton disabled={false} color="secondary" onClick={() => { setVisible(false) }}>
                    Tidak
                </CButton>
                <CLoadingButton loading={loading} color='danger'
                    onClick={() => {
                        setLoading(true)
                        api.get(AUTH_LOGOUT).finally(() => {
                            addToast({ color: "success", message: "Logout berhasil" })
                            localStorage.removeItem('token')
                            setVisible(false)
                            setLoading(false)
                            // navigate(0)
                        });
                    }}
                >
                    Ya, Keluar!
                </CLoadingButton>
            </CModalFooter>
        </CModal>
    )

}

function ModalSetting({ visible, setVisible }: { visible: boolean, setVisible: (x: boolean) => void }) {

    const { setMode, mode, eye, setEye } = useContext(AppContext)
    return (
        <CModal portal backdrop={'static'} visible={visible} onClose={() => { setVisible(false) }}>
            <CModalHeader>
                <CModalTitle>
                    Settings
                </CModalTitle>
            </CModalHeader>
            <CModalBody>
                <CForm className="row">
                    <CFormLabel htmlFor="mode" className="col-4 col-form-label">Mode</CFormLabel>
                    <CCol className='mb-3 col-8'>
                        <CButtonGroup>
                            <CButton title={'Light Mode'} active={mode === 'light'} variant="outline" onClick={() => {
                                setMode('light')
                            }}><CIcon icon={cilSun} /> Light</CButton>
                            <CButton title={'Dark Mode'} active={mode === 'dark'} variant="outline" onClick={() => {
                                setMode('dark')
                            }}><CIcon icon={cilMoon} /> Dark</CButton>
                            <CButton title={'Auto Mode'} active={mode === null} variant="outline" onClick={() => {
                                setMode(null)
                            }}><CIcon icon={cilContrast} /> Auto</CButton>
                        </CButtonGroup>
                    </CCol>

                    <CFormLabel htmlFor="mode" className="col-4 col-form-label">Nominal Visibility</CFormLabel>
                    <CCol className='mb-3 col-8'>
                        <CButtonGroup>
                            <CButton title={'Visible'} active={eye !== 'close'} variant="outline" onClick={() => {
                                setEye("open")
                            }}><CIcon icon={cilEye} /> Visible</CButton>
                            <CButton title={'Hidden'} active={eye === 'close'} variant="outline" onClick={() => {
                                setEye('close')
                            }}><CIcon icon={cilEyeSlash} /> Hidden</CButton>
                        </CButtonGroup>
                    </CCol>
                </CForm>

            </CModalBody>
        </CModal>
    )

}